<template>
    <div class="card mt-3">
        <div class="card-header">
            Google Calendar
        </div>
        <div class="card-body">
            <div v-if="isConnected">
                <p class="text-success"><i class="fa fa-check-circle"></i> Conectado com a conta {{ google_calendar_email || 'Google Calendar' }}</p>
                <div class="btn-group">
                    <button type="button" class="btn btn-danger" @click="disconnect">Desconectar dados do Google</button>
                    <button type="button" class="btn btn-secondary" @click="sync" :disabled="syncing">
                        <i class="fa" :class="syncing ? 'fa-spin fa-refresh' : 'fa-refresh'"></i> {{ syncing ? 'Sincronizando...' : 'Sincronizar agora' }}
                    </button>
                </div>
            </div>
            <div v-else>
                <p>Vincule sua conta do Google para sincronizar suas reuniões e prazos.</p>
                <button type="button" class="btn btn-primary" @click="connect">
                    <i class="fa fa-google"></i> Conectar Google Calendar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import BaseComponent from './BaseComponent'
import {H} from 'hennig-common'

export default {
    name: 'GoogleCalendarSync',
    extends: BaseComponent,
    data() {
        return {
            google_calendar_token: null,
            google_calendar_enabled: false,
            google_calendar_id: null,
            google_calendar_email: null,
            syncing: false
        }
    },
    computed: {
        isConnected() {
            return !!(this.google_calendar_token || this.google_calendar_enabled);
        }
    },
    methods: {
        connect() {
            H.rpc('GoogleCalendarController', 'connect', [], (r) => {
                if (r && r.url) {
                    window.location.href = r.url
                }
            })
        },
        disconnect() {
            if (confirm('Deseja realmente desconectar sua conta do Google?')) {
                H.rpc('GoogleCalendarController', 'disconnect', [], (r) => {
                    if (r && r.success) {
                        location.reload()
                    }
                })
            }
        },
        sync() {
            this.syncing = true
            H.rpc('GoogleCalendarController', 'sync', [], (r) => {
                this.syncing = false
                if (r && r.success) {
                    H.success(r.message)
                }
            })
        }
    }
}
</script>
